import { Button } from 'tradera/components/atoms/button/button';
import { useTranslator } from 'tradera/lang/translate';
import styles from './bin-modal-bottom-buttons.module.scss';
import { CurrencyConversionInfoModal } from '../currency-conversion-info-modal';

type ButtonProps = {
    text: string;
    className?: string;
    disabled: boolean;
    action: () => void;
    isCommitOnPayment?: boolean;
};

type BottomButtonsProps = {
    leftButton: ButtonProps;
    rightButton: ButtonProps;
};

export const BottomButtons = ({
    leftButton,
    rightButton
}: BottomButtonsProps) => {
    const { t } = useTranslator();

    return (
        <div className="d-flex mb-1 mb-md-3 flex-column flex-md-row align-items-end w-100 gap-1">
            <div className={`mr-md-3 ${styles.buttonWrapper}`}>
                <CurrencyConversionInfoModal className="pb-1" isBin />
                <Button
                    size="md"
                    fluid
                    variant="outline"
                    className={leftButton.className}
                    disabled={leftButton.disabled}
                    onClick={leftButton.action}>
                    {t(leftButton.text)}
                </Button>
            </div>
            <div className={styles.buttonWrapper}>
                {!rightButton.isCommitOnPayment && (
                    <em className="mt-1 mt-md-0 mb-1 mb-md-2 d-block">
                        {t('checkout_bin_description2')}
                    </em>
                )}
                <Button
                    size="md"
                    fluid
                    className={rightButton.className}
                    disabled={rightButton.disabled}
                    onClick={rightButton.action}>
                    {t(rightButton.text)}
                </Button>
            </div>
        </div>
    );
};
